import { useSelector } from 'react-redux';
import { UserHeader } from '../../../../components/user-header';
import { selectUser, selectUserSchool } from '../../../../slices/auth';
import Usernames from '../../../../features/Settings/AdminSettings/Usernames';
import {
  useGetAllGamesQuery,
  useGetStudentInGameNameByIdQuery,
} from '../../../../slices/gameApiSlice';
import { Outlet, useNavigate } from 'react-router';
import { Key, ReactElement, JSXElementConstructor, ReactNode, ReactPortal } from 'react';
import { useGetAllTeamsQuery } from '../../../../slices/teamsApiSlice';
import TeamCard from '../../../../components/dashboard/team-card';
import HowlingWolf from '../../../../components/howling-wolf';

const StudentDashboardMyProfile = () => {
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const school = useSelector(selectUserSchool);
  const { data: studentInGameNames, isLoading: inGameNamesLoading } =
    useGetStudentInGameNameByIdQuery(user.id);
  const { data: gamesData, isLoading: gamesLoading, error: gamesError } = useGetAllGamesQuery('');
  const {
    data: teamData,
    isLoading,
    error,
  } = useGetAllTeamsQuery({ query: {}, noPagination: true, showMy: true });

  const userHasNoUsernames = studentInGameNames?.length === 0 && teamData?.length > 0;
  return (
    <div>
      <div className='flex flex-col gap-5'>
        <UserHeader
          lastName={user.lastName}
          name={user.firstName}
          school={school ? school.name : ''}
          schoolId={school ? school.id : ''}
          image={user.image}
          id={user.id}
          username={user.username}
        />
        {/* <StudentDashLiveMatches />
                  <StudentDashUpMatches /> */}
      </div>
      <span className='flex gap-5 mb-12'>
        <p>Date Joined: {new Date(user.createdAt).toLocaleDateString()}</p>
        <p>Email: {user.email}</p>
      </span>
      {userHasNoUsernames && (
        <div
          className='flex text-white bg-fen-red p-2 rounded-lg mb-5 cursor-pointer'
          onClick={() => navigate('add')}
        >
          <p className='text-white bg-fen-red font-bold'>WARNING:&nbsp;</p>
          You do not have any game title Usernames, please add one.
        </div>
      )}
      {!gamesLoading &&
        !isLoading &&
        !inGameNamesLoading &&
        [
          ...new Set(
            user.team
              .filter(
                (team: any) =>
                  !studentInGameNames
                    ?.map((inGameName: { game_id: any }) => inGameName.game_id)
                    .includes(team.game_id),
              )
              .map((team: any) => team.game_id),
          ),
        ].map((uniqueGameId: any) => {
          const gameName = gamesData?.find((game: any) => game.id === uniqueGameId)?.name;
          return (
            <div
              key={uniqueGameId}
              className='flex text-white bg-fen-red p-2 rounded-lg mb-5 cursor-pointer'
              onClick={() => navigate(`add/${uniqueGameId}`)}
            >
              <p className='text-white bg-fen-red font-bold'>WARNING:&nbsp;</p>
              You do not have a username for {gameName}. Please add one.
            </div>
          );
        })}
      <Usernames />
      <h1 className='text-3xl font-bold mb-4'>My Teams</h1>
      {teamData?.length ? (
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5'>
          {teamData?.map((team: any) => (
            <TeamCard key={team.id} team={team} />
          ))}
        </div>
      ) : (
        <>
          <HowlingWolf />
          <p className='flex justify-center '>No teams found.</p>
        </>
      )}

      <Outlet />
    </div>
  );
};

export default StudentDashboardMyProfile;
